import { FC } from 'react';
import { useEffect, useRef } from 'react';

import FullCalendar, { EventSourceInput } from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { QueriedData } from '../../assets/useAssets';
import { AggregatedBooking } from '../useBookings';
import {
  BaseCalendarProps,
  CalendarOptionsWithRef,
} from '../../calendar-types';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';

// Colors
export const calendarsColor = {
  Travel: 'travel',
  Social: 'social',
  Work: 'work',
  Important: 'important',
};

export interface Props extends BaseCalendarProps {
  bookingsQuery: QueriedData<AggregatedBooking[]>;
}
export const Calendar: FC<Props> = (props) => {
  const calendarRef = useRef<FullCalendar>(null);
  const {
    dispatch,
    blankEvent,
    calendarApi,
    selectEvent,
    updateEvent,
    setCalendarApi,
    showModal,
    bookingsQuery,
  } = props;
  useEffect(() => {
    if (calendarApi === null && calendarRef.current) {
      setCalendarApi(calendarRef.current.getApi());
    }
  }, [calendarApi]);

  const events: EventSourceInput = [];
  props.bookingsQuery.data?.forEach((b) => {
    events.push({
      id: b.id,
      title: `${b.service.name} (${b.colaborator.name})`,
      start: new Date(b.date),
      end: dayjs(b.date).add(b.serviceDurationInMinutes, 'minutes').toDate(),
      allDay: false,
      extendedProps: b,
    });
  });
  const history = useHistory();
  function openBooking(bookingID: string) {
    history.push(`/apps/cockpit/bookings/${bookingID}`);
  }

  const calendarOptions: CalendarOptionsWithRef = {
    events,
    plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin],
    initialView: 'dayGridMonth',
    headerToolbar: {
      start: 'prev,next,title',
      end: 'dayGridMonth,timeGridWeek,timeGridDay',
    },
    editable: true,
    eventResizableFromStart: true,
    dragScroll: true,
    dayMaxEvents: 3,
    navLinks: true,

    eventClick({ event: clickedEvent }) {
      openBooking(clickedEvent.extendedProps.id);
    },

    dateClick(info) {
      const ev = blankEvent;
      ev.start = info.date;
      ev.end = info.date;
      dispatch(selectEvent(ev));
    },

    eventDrop({ event: droppedEvent }) {
      dispatch(updateEvent(droppedEvent));
    },

    eventResize({ event: resizedEvent }) {
      dispatch(updateEvent(resizedEvent));
    },

    ref: calendarRef,
  };

  return <FullCalendar {...calendarOptions} />;
};

export default Calendar;
